var _path, _path2, _path3, _g, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 145,
    viewBox: "0 0 140 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7801 76.2007C17.8609 44.7514 41.7987 26.955 51.0164 21.7996C85.8159 5.07255 102.211 24.4917 100.641 43.5546C98.7755 66.2034 66.352 64.8516 73.4227 85.6924C75.6634 92.2967 86.5734 105.044 72.004 112.34C57.4346 119.635 31.1792 115.512 23.7801 76.2007Z",
    fill: "#F5EFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2652 77.4631C105.712 75.2856 117.813 81.2459 119.961 89.5776C122.109 97.9093 118.212 105.849 109.766 108.026C101.319 110.204 91.5208 105.795 89.3729 97.4633C87.225 89.1316 88.8186 79.6407 97.2652 77.4631Z",
    fill: "#F5EFEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54H59C56.525 54 54.5225 56.025 54.5225 58.5L54.5 85.5C54.5 87.975 56.525 90 59 90H95C97.475 90 99.5 87.975 99.5 85.5V58.5C99.5 56.025 97.475 54 95 54ZM95 85.5H59V63L77 74.25L95 63V85.5ZM77 69.75L59 58.5H95L77 69.75Z",
    fill: "#D0765B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 50.5,
    r: 14.5,
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.296 53.8127L43.3526 49.8694L42.0098 51.2027L47.296 56.4889L58.6438 45.1411L57.3104 43.8077L47.296 53.8127Z",
    fill: "#F38C6C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 29,
    y: 33,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.168627 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmEmail);
export default __webpack_public_path__ + "static/media/confirm-email.427fbafa7b517a01db9cf8e22863910b.svg";
export { ForwardRef as ReactComponent };